import React, { Fragment } from "react";
import {
  useCouponPromotionCodes,
  useProduct,
  useProductsPrices,
  useShippingRates,
  useTaxRates
} from "utils/selectors";
import ContactlessPaymentLink from "components/ContactlessPaymentLink";
import { prepareProductCollectionItem } from "components/FormerEditor/common";
import {
  getShortLinkCheckoutUrl,
  reduceShortLinkReferences
} from "utils/shortLink";

const ContactlessCard = ({
  shortLink,
  children,
  test = false,
  contactless = true,
  codeSizeFactor,
  widthFactor,
  heightFactor,
  code
}) => {
  const { products, prices } = useProductsPrices();
  const { coupons } = useCouponPromotionCodes();
  const taxRates = useTaxRates();
  const shippingRates = useShippingRates();

  const references = reduceShortLinkReferences(shortLink);
  const product = useProduct(references.products[0]);

  const input = {
    shortLink,
    products,
    prices,
    coupons,
    taxRates,
    shippingRates,
    test
  };
  if (product) {
    input.product = {
      title: product.name,
      description: product.description
    };
  }

  const liveUrl = shortLink
    ? getShortLinkCheckoutUrl({
        id: shortLink.short_id,
        test: test
      })
    : "";

  const prepared = prepareProductCollectionItem(input);

  return (
    <Fragment>
      <ContactlessPaymentLink
        {...prepared}
        liveUrl={liveUrl}
        contactless={contactless}
        code={code}
        test={test}
        codeSizeFactor={codeSizeFactor}
        widthFactor={widthFactor}
        heightFactor={heightFactor}
      />
      {children}
    </Fragment>
  );
};

export default ContactlessCard;
